import React, { useState } from 'react';
import CryptoNetworkSelect from './CryptoNetworkSelect';
import CryptoWalletDetails from './CryptoWalletDetails';
import CryptoTransactionForm from './CryptoTransactionForm';
import './Deposit.css';

const CryptoDeposit = ({ onSuccess }) => {
  const [currentStep, setCurrentStep] = useState('network');
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [selectedWallet, setSelectedWallet] = useState(null);

  const handleNetworkSelect = (network) => {
    setSelectedNetwork(network);
    setCurrentStep('wallet');
  };

  const handleWalletSelect = (wallet) => {
    setSelectedWallet(wallet);
    setCurrentStep('transaction');
  };

  const handleBack = () => {
    if (currentStep === 'transaction') {
      setCurrentStep('wallet');
    } else if (currentStep === 'wallet') {
      setCurrentStep('network');
      setSelectedNetwork(null);
    }
  };

  const handleTransactionSubmit = () => {
    onSuccess();
  };

  return (
    <div className="crypto-deposit">
      {currentStep === 'network' && (
        <CryptoNetworkSelect onNetworkSelect={handleNetworkSelect} />
      )}
      
      {currentStep === 'wallet' && (
        <CryptoWalletDetails 
          network={selectedNetwork}
          onWalletSelect={handleWalletSelect}
          onBack={handleBack}
        />
      )}
      
      {currentStep === 'transaction' && (
        <CryptoTransactionForm 
          network={selectedNetwork}
          wallet={selectedWallet}
          onSubmit={handleTransactionSubmit}
          onBack={handleBack}
        />
      )}
    </div>
  );
};

export default CryptoDeposit;